import type { ComponentChildren } from 'preact'
import { ChevronRight } from 'lucide-preact'

export type BreadcrumbItem = {
  text: string
  href?: string
}

interface PageHeaderProps {
  items: BreadcrumbItem[]
  actions?: ComponentChildren
  className?: string
}

export function PageHeader({ items, actions, className = '' }: PageHeaderProps) {
  const lastIndex = items.length - 1
  return (
    <div className={`flex items-center justify-between py-2 ${className}`}>
      <nav aria-label="Breadcrumb" className="flex items-center gap-1 text-sm">
        {items.map((item, idx) => {
          const isLast = idx === lastIndex
          return (
            <div key={`${item.text}-${idx}`} className="flex items-center">
              {idx > 0 && <ChevronRight className="w-4 h-4 text-slate-400 mx-1" aria-hidden="true" />}
              {item.href && !isLast ? (
                <a href={item.href} className="text-slate-600 hover:text-slate-900 dark:text-slate-300 dark:hover:text-white">
                  {item.text}
                </a>
              ) : (
                <span className="text-slate-900 dark:text-slate-100 font-medium" aria-current="page">{item.text}</span>
              )}
            </div>
          )
        })}
      </nav>
      {actions && (
        <div className="flex items-center gap-2">{actions}</div>
      )}
    </div>
  )
}
